import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import type { Exact } from "@Helpers/types/exact";
import type {
  DeleteAppearanceRequest,
  DeleteAppearanceResponse,
  AddEditAppearanceRequest,
  AddEditAppearanceResponse,
} from "@ServerTypes/tasks/tasks.schema";
import type {
  LinkBoqItemsRequest,
  LinkBoqItemsResponse,
  GetBoqItemsRequest,
  GetBoqItemsResponse,
} from "@ServerTypes/contracts/contracts.schema";

export const deleteAppearance = async <T extends Exact<DeleteAppearanceRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<DeleteAppearanceResponse>(
    `${getBackendUrl()}/schedule/deleteAppearance`,
    data,
  );
  return response;
};
export const addEditAppearance = async <T extends Exact<AddEditAppearanceRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<AddEditAppearanceResponse>(
    `${getBackendUrl()}/schedule/addEditAppearance`,
    data,
  );
  return response;
};
export const linkBoqItems = async <T extends Exact<LinkBoqItemsRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<LinkBoqItemsResponse>(`${getBackendUrl()}/contracts/linkBoqItems`, data);
  return response;
};
export const getBoqItems = async <T extends Exact<GetBoqItemsRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<GetBoqItemsResponse>(`${getBackendUrl()}/contracts/getBoqItems`, data);
  return response;
};
